<template>
  <div class="container chronic-condition">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="12" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip skip="howpandemicaffected">
    </back-and-skip>
    <div class="row pt-5 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/chronic_condition.svg" alt="unknow-condition">
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('chronicCondition.title') }}
        </label>
      </div>
    </div>
    <div class="row pt-4">
      <div class="offset-1 col-10 offset-md-2 col-md-8 text-center">
        <div class="row">
          <div class="col-2 offset-md-2 col-md-1 condition-option">
            <input value="Asthma" type="checkbox" id="asthma" @change="check('Asthma')">
            <label for="asthma"></label>
          </div>
          <div class="col-2 col-md-1 pl-0">
            <figure class="figure">
              <img src="../assets/asthma.png" class="figure-img img-fluid ">
              <figcaption class="figure-caption">{{ $t('chronicCondition.asthma') }}</figcaption>
            </figure>
          </div>
          <div class="col-2 offset-md-1 col-md-1 condition-option">
            <input type="checkbox" id="copd" @change="check('COPD')">
            <label for="copd"></label>
          </div>
          <div class="col-2 col-md-1">
            <figure class="figure">
              <img src="../assets/copd.png" class="figure-img img-fluid ">
              <figcaption class="figure-caption">{{ $t('chronicCondition.copd') }}</figcaption>
            </figure>
          </div>
          <div class="col-2 offset-md-1 col-md-1 condition-option">
            <input type="checkbox" id="hearth-disease" @change="check('Heart Disease')">
            <label for="hearth-disease"></label>
          </div>
          <div class="col-2 col-md-1 pl-0">
            <figure class="figure">
              <img src="../assets/hearth.png" class="figure-img img-fluid ">
              <figcaption class="figure-caption">{{ $t('chronicCondition.heart') }}</figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="offset-1 col-10 offset-md-2 col-md-8 text-center">
        <div class="row">
          <div class="col-2 offset-md-2 col-md-1 condition-option">
            <input type="checkbox" id="diabetes" @change="check('Diabetes')">
            <label for="diabetes"></label>
          </div>
          <div class="col-2 col-md-1 pl-0">
            <figure class="figure">
              <img src="../assets/diabetes.png" class="figure-img img-fluid ">
              <figcaption class="figure-caption">{{ $t('chronicCondition.diabetes') }}</figcaption>
            </figure>
          </div>
          <div class="col-2 offset-md-1 col-md-1 condition-option">
            <input type="checkbox" id="hypertension" @change="check('Hypertension')">
            <label for="hypertension"></label>
          </div>
          <div class="col-2 col-md-1 pl-0">
            <figure class="figure">
              <img src="../assets/hypertension.png" class="figure-img img-fluid ">
              <figcaption class="figure-caption" style="font-size: 0.6rem">{{ $t('chronicCondition.hypertension') }}</figcaption>
            </figure>
          </div>
          <div class="col-2 offset-md-1 col-md-1 condition-option">
            <input type="checkbox" id="autoinmmune-disease" @change="check('Autoimmune Disease')">
            <label for="autoinmmune-disease"></label>
          </div>
          <div class="col-2 col-md-1 pl-0">
            <figure class="figure">
              <img src="../assets/ad.svg" class="figure-img img-fluid ad-img">
              <figcaption class="figure-caption" style="font-size: 0.6rem">{{ $t('chronicCondition.ad') }}</figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
    <yes-no
    @yes="yes"
    @no="no">
    </yes-no>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import BackAndSkip from '../components/BackAndSkip.vue'
import YesNo from '../components/YesNoButtons.vue'

export default {
  data () {
    return {
      conditions: []
    }
  },
  components: {
    BackAndSkip,
    YesNo
  },
  methods: {
    check (value) {
      if (this.conditions.includes(value)) {
        const index = this.conditions.indexOf(value)
        this.conditions.splice(index, 1)
      } else {
        this.conditions.push(value)
      }
    },
    yes () {
      const answer = {
        key: 'have_an_existing_chronic_condition',
        value: 'yes'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      if (this.conditions.length > 0) {
        const answerConditions = {
          key: 'chronic_conditions',
          value: this.conditions
        }

        this.$store.commit('SET_DATA_SURVEY', answerConditions)

        this.$router.push({
          name: 'howpandemicaffected'
        })
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('general.oneItemError')
        })
      }
    },
    no () {
      const answer = {
        key: 'have_an_existing_chronic_condition',
        value: 'no'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      this.$router.push({
        name: 'howpandemicaffected'
      })
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'chroniccondition')
  },
  validations: {
    conditions: {
      required,
      minLength: minLength(1)
    }
  }
}
</script>

<style>
.chronic-condition .img-question {
  width: 100%;
  height: 22vh;
}

.chronic-condition .title {
  font-weight: 700;
  font-size: 1.4rem;
}

.condition-option input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.condition-option label {
  position: relative;
  cursor: pointer;
}

.condition-option label:before {
  content:'';
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #e3e3e3;
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
}

.condition-option input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 2px;
  left: 9px;
  width: 7px;
  height: 15px;
  border: solid #34ace0;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.chronic-condition .ad-img {
  width: 32px;
  height: 31px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .chronic-condition .img-question {
    width: 100%;
    height: 20vh;
  }

  .chronic-condition .title {
    font-weight: 700;
    font-size: 1.3rem;
  }
}
</style>
